const daysOfWeek = '(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\\s*';
const months =
  '(Jan(?:uary)?|Feb(?:ruary)?|Mar(?:ch)?|Apr(?:il)?|May|Jun(?:e)?|Jul(?:y)?|Aug(?:ust)?|Sep(?:tember)?|Oct(?:ober)?|Nov(?:ember)?|Dec(?:ember)?)';
const days = '\\d{1,2}';
const years = '\\d{4}';
const daysWithLeadingZero = '\\d{2}';
const dateFormats = [
  `${months}[\\s,]*${days}[\\s,]*(?:${years})?`,
  `${days}\\s*${months}\\s*(?:${years})?`,
  `${years}-${daysWithLeadingZero}-${daysWithLeadingZero}`,
  `${daysWithLeadingZero}-${daysWithLeadingZero}-${years}`,
  `${daysOfWeek}${days}\\s*${months}\\s*${years}`,
  `${years}-${daysWithLeadingZero}-${daysWithLeadingZero}-\\w+`,
  `${months}\\s*${days}`,
];

const datePattern = new RegExp(
  `(?:${daysOfWeek})?(?:${dateFormats.join('|')})`,
  'gi' // gフラグ：文章内のすべてのマッチ対象を抽出。 iフラグ：大文字小文字を気にしない（ignore case）
);

export const removeDateWords = (label: string): string => {
  return label
    .replace(datePattern, '')
    .replace(/\s{2,}/g, ' ') // gフラグをつけて、すべての２文字以上の空白（\s{2,})を置換する。
    .trim();
};
